import { Box, Button } from '@material-ui/core'

import { useStyles } from './styles'

interface ViewDiagnosisButtonProps {
  href?: string
}

export const ViewDiagnosisButton = ({ href }: ViewDiagnosisButtonProps) => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <Button
        className={classes.root}
        startIcon={<span className='material-symbols-outlined'>window</span>}
        component='a'
        href={href}
        target='_blank'
        rel='noopener noreferrer'
      >
        Ver diagnóstico completo
      </Button>
    </Box>
  )
}
